import React from 'react';
import { greys, mainColors } from '../../../../../../styling/theme';
import makeStyles from '@mui/styles/makeStyles';
import MancoPieChart from '../MancoPieChart/mancoPieChart.component';
import { Tooltip } from '@mui/material';
import type { EmirMancoSectionSummary } from '../../../../../../api/rs-hg/emir';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    paddingTop: '1.25rem',
    alignItems: 'center',
    justifyContent: 'flex-start',
    backgroundColor: 'white',
    borderRadius: '0.25rem',
    padding: '0 0.62rem',
    width: '9.38rem',
    '&:hover': {
      backgroundColor: greys.grey100,
    },
  },
  pie: {
    pointer: 'cursor',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
  percentageText: {
    fontSize: '1.12rem',
    fontWeight: 500,
    color: mainColors.mainBlue,
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
  title: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    fontSize: '1.25rem',
    textAlign: 'center',
    width: '100%',
    padding: '0.12rem 0.31rem',
    fontWeight: 500,
    bottom: 20,
    color: mainColors.mainBlue,
    backgroundColor: 'transparent',
    borderRadius: '0.25rem',
  },
}));

export interface IndividualPieProps {
  section: EmirMancoSectionSummary;
  isSelectedKey: boolean;
  handlePieClick: () => void;
}

const IndividualPie: React.FC<IndividualPieProps> = ({
  section,
  isSelectedKey,
  handlePieClick,
}) => {
  const classes = useStyles();
  const pieData = [
    { name: 'Pass', value: section.pass },
    { name: 'Fail', value: section.fail },
  ];
  const percentageLabel = `${Math.round(section.percentage_pass * 100)}%`;

  return (
    <Tooltip title={`Filter ${section.label}`}>
      <div className={classes.root} onClick={handlePieClick}>
        <div className={classes.pie}>
          <MancoPieChart data={pieData} animBegin={0} />
          <div className={classes.percentageText}>{percentageLabel}</div>
        </div>
        <div
          className={classes.title}
          style={{
            backgroundColor: isSelectedKey
              ? mainColors.mainBlue_slightlyDarker
              : 'transparent',
            color: isSelectedKey ? 'white' : mainColors.mainBlue,
          }}
        >
          {section.label}
        </div>
      </div>
    </Tooltip>
  );
};

export default React.memo(IndividualPie);